// frontend/src/components/ZohoBlockModal.js
import React from "react";
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter,
  ModalCloseButton, Button, Text, Box, VStack,
} from "@chakra-ui/react";

export default function ZohoBlockModal({ blockEmail, onClose }) {
  if (!blockEmail) return null;
  return (
    <Modal isOpen onClose={onClose} size="2xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Zoho outgoing email blocked</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack align="stretch" spacing={3}>
            <Text fontSize="sm" color="gray.600">
              From {blockEmail.from || "noreply@zoho.com"} · received {blockEmail.received_at || "—"}
            </Text>
            <Text fontWeight="bold">{blockEmail.subject}</Text>
            <Box borderWidth="1px" borderRadius="md" overflow="hidden" bg="white">
              <iframe
                title="Zoho block email"
                srcDoc={blockEmail.html_body || `<pre>${(blockEmail.text_body || "").replace(/[<>&]/g, c => ({"<":"&lt;",">":"&gt;","&":"&amp;"}[c]))}</pre>`}
                sandbox="allow-popups allow-popups-to-escape-sandbox"
                style={{ width: "100%", height: 360, border: 0 }}
              />
            </Box>
            {!blockEmail.unblock_url && (
              <Text fontSize="sm" color="orange.600">
                We couldn't find a "click here" link in this email — please open it in Zoho Mail directly.
              </Text>
            )}
          </VStack>
        </ModalBody>
        <ModalFooter gap={2}>
          {blockEmail.unblock_url && (
            <Button as="a" href={blockEmail.unblock_url} target="_blank" rel="noopener noreferrer" colorScheme="orange">
              Open unblock link
            </Button>
          )}
          <Button variant="ghost" onClick={onClose}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
